import { memo } from 'react';
import { motion } from 'framer-motion';

import { useGetParams } from '../../hooks/useGetParams';

import { BgVideo } from '../BgVideo/BgVideo';

import styles from './Advt.module.css';

import logo from '../../assets/images/logo.png';

export const Advt = memo(({ title }) => {
  const { qrCode1, qrCode2, titleFontSize, sizeQR } = useGetParams();

  const wordsTitle = title?.split(/\r?\n/);

  const config = [
    { color: ['#A2D9F7', '#008DD2', '#ffffff'], fontSize: '9.375rem' },
    {
      color: ['#A2D9F7', '#008DD2', '#A2D9F7'],
      fontSize: '15.1rem',
      fontFamily: 'TT-Hoves-Pro-Trial-Condensed-Black, sans-serif',
    },
    { color: ['#A2D9F7', '#008DD2', '#ffffff'], fontSize: '7.81rem' },
  ];

  return (
    <div className={styles.advtBlock}>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className={styles.logoBlock}
      >
        <img src={logo} alt="" />
      </motion.div>

      {wordsTitle && (
        <div
          className={styles.title}
          style={{ fontSize: `${titleFontSize}rem` }}
        >
          {wordsTitle.map((w, idx) => (
            <motion.div
              style={{
                fontSize: config[idx]?.fontSize,
                fontFamily: config[idx]?.fontFamily,
              }}
              key={w + idx}
              initial={{ scale: 0, color: '#A2D9F7' }}
              animate={{ scale: 1, color: config[idx]?.color }}
              transition={{
                color: {
                  delay: 1.4 + idx * 0.5,
                  duration: 0.6,
                  ease: ['easeIn', 'easeIn'],
                },

                scale: {
                  duration: 0.68,
                  delay: 1.4 + idx * 0.5,
                  ease: 'easeIn',
                },
              }}
            >
              {w}
            </motion.div>
          ))}
        </div>
      )}

      <div className={styles.qrsWrapper}>
        {qrCode1 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.15, 1] }}
            transition={{
              duration: 1.48,
              ease: 'easeInOut',
              times: [0, 0.85, 1],
            }}
            className={styles.qrCode}
          >
            <img
              src={qrCode1}
              alt="QR"
              style={{
                height: `${sizeQR}rem`,
                width: `${sizeQR}rem`,
              }}
            />
          </motion.div>
        )}
        {qrCode2 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.15, 1] }}
            transition={{
              duration: 1.48,
              ease: 'easeInOut',
              times: [0, 0.85, 1],
            }}
            className={styles.qrCode}
          >
            <img
              src={qrCode2}
              alt="QR"
              style={{
                width: `${sizeQR}rem`,
                height: `${sizeQR}rem`,
              }}
            />
          </motion.div>
        )}
      </div>

      <BgVideo />
    </div>
  );
});
